module.exports = __webpack_public_path__ + "img/9.916dd3e7.jpg";